module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAsAAAAOCAYAAAD5YeaVAAAACXBIWXMAAAsTAAALEwEAmpwYAAAA8ElEQVQokXXQvUoDQRSG4WfCrhptU0YsYmkjiAgi2HgRXoBFOoONjbWlEMRCIZdhZZFCbS1sbAVvQCMoK9mxMAvjuh448H1z3vPDhPg20hBreMYkfWw1gH084gHd33DIJdkX8ouZ7gn5WMi7VT0T5qvGQ5zVtvQwxi5eMmEBjnHadPys4Q7bmdDu4BMDbGI/Ad9xMtOrIX7cplMOcJn4G+xVJtNaTOGV2gnXqcmEpdRvJXqCUQ1uV7qDnaR2hNf/4AHmZvocV7WThDidwAbuMfXzjUPEOiyWxXosi6dYFsNYFsuxLPyXIcaY4+vPlIb4BsS6Sh+IaONnAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/components/pumpMonitor/leftTwo/up.png
// module id = KyhS
// module chunks = 157